import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function Launch() {
  const navigate = useNavigate();

  useEffect(() => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    const isAndroid = /android/i.test(userAgent);
    const isIOS = /iPad|iPhone|iPod/.test(userAgent);

    const playStoreURL =
      "https://play.google.com/store/apps/details?id=com.tringbox.tringdj";
    const appStoreURL =
      "https://apps.apple.com/in/app/tringbox-partner/id6753770166?l=mr";

    // Deep link scheme for the app
    const deepLink = "tringbox://launch";

    if (isAndroid) {
      // Try to open the app via deep link
      const iframe = document.createElement("iframe");
      iframe.style.display = "none";
      iframe.src = deepLink;
      document.body.appendChild(iframe);

      // Fallback to Play Store after timeout
      const fallbackTimer = setTimeout(() => {
        window.location.href = playStoreURL;
      }, 1500);

      window.addEventListener("pagehide", () => {
        clearTimeout(fallbackTimer);
      });
    } else if (isIOS) {
      // Try to open the app via deep link
      window.location.href = deepLink;

      // Fallback to App Store after timeout
      setTimeout(() => {
        window.location.href = appStoreURL;
      }, 1500);
    } else {
      // Desktop: redirect to "/" with a query param to trigger the modal
      navigate("/?launch=true", { replace: true });
    }
  }, [navigate]);

  // Show a minimal loading state while deep link is attempted
  return (
    <div className="flex items-center justify-center w-screen h-screen bg-purple-50">
      <div className="text-center">
        <img
          src="/images/logo.svg"
          alt="Tringbox"
          className="w-16 h-16 mx-auto mb-4"
        />
        <p className="text-purple-600 font-medium">Opening Tringbox app...</p>
        <p className="text-gray-400 text-sm mt-2">
          If the app doesn't open,{" "}
          <a
            href="https://play.google.com/store/apps/details?id=com.tringbox.tringdj"
            className="text-purple-600 underline"
          >
            download it here
          </a>
        </p>
      </div>
    </div>
  );
}
